import React from 'react'
import axios from '~/data/http/axios'
import AddCard from '~/Common-Objects/UI/Payment/addCardStripe'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Column from '~/Common-Objects/Grids/Column/Column'
import DataTable1 from '~/Common-Objects/Tables/DataTable1/DataTable1'
import Drawer from '~/Common-Objects/UI/Drawer/Drawer.jsx'
import Icons from '~/Common-Objects/UI/Icons/index'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import Row from '~/Common-Objects/Grids/Row/Row'
import SnackBar from '~/Common-Objects/UI/Notifications/SnackBar/SnackBar'
import SquareChip from '~/Common-Objects/UI/Chips/SquareChip.jsx'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import { connect } from 'react-redux'
import i18n from '~/i18n'
import moment from 'moment'
import dateTimeFunction from '~/Classes/dateTimeFunctions'
import FailedPaymentConfirmDrawer from './failedPaymentConfirm'
import SiteVars from '~/Classes/siteVars'
//CONNECT TO STORE
@connect((store) => {
    return { user: store.user, permissionStore: store.permission }
})
export default class Payments extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            startDate: moment().subtract(24, 'month'),
            endDate: moment(),
            paymentData: [],
            pageLoaded: false,
            pageSize: 1000,
            currentDrawer: null,
            alertMessage: '',
            alertOpen: false,
            processingPayment: false,
            paymentId: 0,
            stripeLoaded: false,
            downloading: {}
        }

        this.updateDate = this.updateDate.bind(this)
        this.getPayments = this.getPayments.bind(this)
        this.tableUpdater = this.tableUpdater.bind(this)
        this.download = this.download.bind(this)
        this.payInvoice = this.payInvoice.bind(this)
        this.addedCard = this.addedCard.bind(this)
        this.exitPaymentMethod = this.exitPaymentMethod.bind(this)
        this.goPayInvoice = this.goPayInvoice.bind(this)
        this.addCard = this.addCard.bind(this)
    }

    updateDate(dates) {
        this.setState({ startDate: dates.startDate, endDate: dates.endDate }, this.getPayments)
    }

    componentDidMount() {
        this.getPayments()
        const self = this

        async function checkStripe() {
            if (!self.stripe) {
                if (window.Stripe) {
                    self.stripe = Stripe(SiteVars.stripeKey)
                    self.setState({ stripeLoaded: true })
                } else {
                    await new Promise((resolve, reject) => {
                        setTimeout(resolve, 300)
                    })
                    checkStripe()
                }
            }
        }
        checkStripe()
    }

    async getPayments() {
        const res = await axios.get(
            '/accountMaster/payments?startDate=' +
                this.state.startDate.startOf('day').format('YYYY-MM-DD HH:mm:ss') +
                '&endDate=' +
                this.state.endDate.endOf('day').format('YYYY-MM-DD HH:mm:ss')
        )
        this.setState({ paymentData: res.data.payments, pageLoaded: true })
    }

    tableUpdater() {}

    download(id) {
        this.state.downloading[id] = true
        this.setState({ downloading: this.state.downloading })
        axios
            .get('/accountMaster/payments/' + id + '/invoice', {
                responseType: 'blob'
            })
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'invoice.pdf')
                document.body.appendChild(link)
                link.click()
                delete this.state.downloading[id]
                this.setState({ downloading: this.state.downloading })
            })
    }

    payInvoice(paymentId) {
        if (this.state.processingPayment) return
        this.setState({ paymentId: paymentId, processingPayment: true }, this.goPayInvoice)
    }

    goPayInvoice() {
        var self = this
        this.setState({
            alertOpen: true,
            alertMessage: i18n.t('company:payments.processingPayment'),
            currentDrawer: null,
            processingPayment: true
        })
        axios
            .put('/accountMaster/payment/' + self.state.paymentId)
            .then((response) => {
                if (response.data.Success) {
                    self.setState(
                        {
                            alertOpen: true,
                            alertMessage: i18n.t('company:payments.paymentProcessed'),
                            processingPayment: false,
                            currentDrawer: null
                        },
                        self.getPayments
                    )
                } else {
                    this.props.history.push('/cp/company/authpayment')
                }
            })
            .catch((err) => {
                var drawer = (
                    <Drawer
                        standalone={true}
                        isOpen={true}
                        width='500px'
                        showClose={true}
                        close={this.exitPaymentMethod}
                        className='right'
                    >
                        <FailedPaymentConfirmDrawer
                            reChard={this.goPayInvoice}
                            addCard={this.addCard}
                            err={err.data.error}
                        />
                    </Drawer>
                )
                self.setState({
                    alertOpen: true,
                    alertMessage: i18n.t('company:payments.errorProcessingPayment'),
                    processingPayment: false,
                    error: err.data.error,
                    currentDrawer: drawer
                })
            })
    }

    addCard() {
        var self = this
        this.setState(
            {
                currentDrawer: null
            },
            () => {
                var drawer = (
                    <Drawer
                        standalone={true}
                        isOpen={true}
                        width='100%'
                        showClose={true}
                        close={self.exitPaymentMethod}
                        className='full'
                    >
                        <AddCard
                            stripe={self.stripe}
                            close={() => {
                                self.addedCard()
                            }}
                        />
                    </Drawer>
                )
                self.setState({
                    currentDrawer: drawer
                })
            }
        )
    }

    addedCard() {
        this.setState(
            {
                currentDrawer: null
            },
            () => {
                this.goPayInvoice()
            }
        )
    }

    exitPaymentMethod() {
        this.setState({ currentDrawer: null })
    }

    render() {
        if (!this.state.pageLoaded || !this.state.stripeLoaded) {
            return <LoadingIcons iconType='2' />
        }

        return (
            <div>
                <Row className='mar-b10 middle-lg middle-md end-xs'>
                    <Column xl='12' xs='12' sm='12' md='3' lg='3'>
                        <div className='form-group form-group-icon mar-b0'>
                            <TextInput
                                type='multiDate'
                                startDate={this.state.startDate}
                                endDate={this.state.endDate}
                                updateDate={this.updateDate}
                            ></TextInput>
                        </div>
                    </Column>
                </Row>

                {this.state.paymentData.length === 0 && (
                    <div style={{ textAlign: 'center' }}>{i18n.t('company:payments.noPaymentsDate')}</div>
                )}
                {this.state.paymentData.length > 0 && (
                    <Paper>
                        <DataTable1
                            noResultsTxt={<div>{i18n.t('company:payments.noPayments')}</div>}
                            tableData={this.state.paymentData.map((thisLine, index) => {
                                var totalPrice = thisLine.totalPrice ? thisLine.totalPrice : thisLine.price
                                var thisPrice = Number(totalPrice).toFixed(2)
                                var thisVAT = Number(thisLine.vatAmount).toFixed(2)

                                var status = (
                                    <SquareChip className='square-chip-green'>
                                        {i18n.t('company:payments.statusPaid')}
                                    </SquareChip>
                                )

                                if (!thisLine.hasPaid) {
                                    if (thisLine.StripeAuthPayment && thisLine.StripeAuthPayment.id) {
                                        status = (
                                            <SquareChip className='square-chip-yellow'>
                                                {i18n.t('company:payments.authorizationRequired')}
                                            </SquareChip>
                                        )
                                    } else if (thisLine.awaitingCollection) {
                                        status = (
                                            <UILIB.SquareChip className='square-chip-yellow'>
                                                {i18n.t('company:payments.statusProcessing')}
                                            </UILIB.SquareChip>
                                        )
                                    } else {
                                        status = (
                                            <SquareChip className='square-chip-red'>
                                                {i18n.t('company:payments.statusNotPaid')}
                                            </SquareChip>
                                        )
                                    }
                                }

                                let currencySymbol = '£'
                                if (thisLine.currency && thisLine.currency == 'USD') currencySymbol = '$'

                                let description
                                if (Array.isArray(thisLine.description)) {
                                    description = (
                                        <>
                                            {thisLine.description.map((_, index) => (
                                                <div key={thisLine.id + '_' + index} style={{ marginBottom: 4 }}>
                                                    <strong>
                                                        {thisLine.productName[index] +
                                                            ' - ' +
                                                            thisLine.description[index]}
                                                    </strong>
                                                </div>
                                            ))}
                                        </>
                                    )
                                } else {
                                    description = <strong>{thisLine.productName + ' - ' + thisLine.description}</strong>
                                }

                                var tmpDat = {
                                    paymentDate: {
                                        headerValue: i18n.t('company:payments.date'),
                                        value: dateTimeFunction.formatDateTime(thisLine.paymentDate),
                                        orderBy: false
                                    },
                                    description: {
                                        headerValue: i18n.t('company:payments.item'),
                                        value: description,
                                        orderBy: false
                                    },
                                    price: {
                                        headerValue: i18n.t('company:payments.price'),
                                        value: (
                                            <strong>
                                                {currencySymbol}
                                                {Number(thisLine.price).toFixed(2)}
                                            </strong>
                                        ),
                                        orderBy: false
                                    },
                                    vatAmount: {
                                        headerValue: i18n.t('company:payments.vat'),
                                        value: currencySymbol + thisVAT,
                                        orderBy: false
                                    },
                                    total: {
                                        headerValue: i18n.t('company:payments.total'),
                                        value: (
                                            <strong>
                                                {currencySymbol}
                                                {thisPrice}
                                            </strong>
                                        ),
                                        orderBy: false
                                    },
                                    status: {
                                        headerValue: i18n.t('company:payments.status'),
                                        value: status,
                                        orderBy: false,
                                        width: 100,
                                        align: 'center'
                                    },
                                    paymentMethod: {
                                        headerValue: i18n.t('company:payments.method'),
                                        value: thisLine.paymentMethod == 'stripe' ? i18n.t('company:payments.card') : thisLine.paymentMethod,
                                        orderBy: false
                                    },
                                    payCol: {
                                        align: 'right',
                                        headerValue: '',
                                        value: '',
                                        orderBy: false,
                                        width: 0
                                    },
                                    download: {
                                        width: 40,
                                        align: 'right',
                                        headerValue: ' ',
                                        value: thisLine.hasPaid && (
                                            <Button
                                                disabled={this.state.downloading[thisLine.id]}
                                                onClick={() => this.download(thisLine.id)}
                                                className='button-sml'
                                                iconRight={
                                                    this.state.downloading[thisLine.id] && (
                                                        <Icons icon='loading' />
                                                    )
                                                }
                                            >
                                                {i18n.t('company:payments.invoice')}
                                            </Button>
                                        )
                                    }
                                }

                                if (!thisLine.hasPaid) {
                                    if (thisLine.StripeAuthPayment && thisLine.StripeAuthPayment.id) {
                                        tmpDat.payCol.value = (
                                            <Button
                                                text={i18n.t('company:payments.authorize')}
                                                className='button-sml outline button-primary'
                                                onClick={() => this.props.history.push('/cp/company/authpayment')}
                                            />
                                        )
                                    } else if (!thisLine.awaitingCollection) {
                                        tmpDat.payCol.value = (
                                            <Button
                                                text={i18n.t('company:payments.payNow')}
                                                className='button-sml outline button-primary'
                                                onClick={() => {
                                                    this.payInvoice(thisLine.id)
                                                }}
                                                disabled={this.state.processingPayment}
                                            />
                                        )
                                    }
                                }
                                return tmpDat
                            })}
                            loadingData={this.state.pageLoaded}
                            dataUpdater={this.tableUpdater}
                            width='100%'
                            pageSize={this.state.pageSize}
                            hasCheckBoxes='no'
                        />
                    </Paper>
                )}

                <SnackBar
                    message={this.state.alertMessage}
                    open={this.state.alertOpen}
                    autoclose={true}
                    dismiss={() => this.setState({ alertOpen: false })}
                />

                {this.state.currentDrawer && this.state.currentDrawer != null && <div>{this.state.currentDrawer}</div>}
            </div>
        )
    }
}
